import collect from 'collect.js';
import { Stringable } from './Stringable';

// Layout is keyed on the region's `address_format` (from the backend), never
// re-derived from a country string client-side.
export default class AddressHelpers {
  static format({ street_name, street_number, city, state, zip_code, note }, addressFormat) {
    const address =
      {
        us: this.implode([this.implode([street_number, street_name], ' '), note, city, state, zip_code]),
        number_city_zip: this.implode([this.implode([street_number, street_name], ' '), city, zip_code]),
        number_zip_city: this.implode([
          this.implode([street_number, street_name], ' '),
          this.implode([zip_code, city], ' '),
        ]),
        international: this.implode([
          this.implode([street_name, street_number], ' '),
          this.implode([zip_code, city], ' '),
        ]),
      }[addressFormat] ??
      this.implode([this.implode([street_name, street_number], ' '), this.implode([zip_code, city], ' ')]);

    return new Stringable(address).squish().toString();
  }

  /** The country-level region's `address_format`; `international` for a country the platform has no region for. */
  static addressFormatFor(regions, country) {
    const countryRegions = collect(regions ?? []).where('country', country);

    return (
      (countryRegions.first((region) => !region.state) ?? countryRegions.first())?.address_format ?? 'international'
    );
  }

  static implode(fields, glue = ', ') {
    return collect(fields)
      .filter((item) => item && item.length > 0)
      .implode(glue)
      .trim();
  }
}
